import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, EMPTY, throwError } from 'rxjs';
import { AlertService } from '../services/local/alert-service';
import { CredentialsService } from '../services/local/credentials.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authService = inject(CredentialsService);
  const alertService = inject(AlertService);
  // Create the basic auth header
  if (req.url.endsWith('/auth/login') || req.url.endsWith('/configs/app')) {
    return next(req);
  }

  const credentials = authService.credentials();

  if (!credentials) {
    router.navigate(['login']);
    return throwError(() => new Error('No hay sesión'));
  }

  const authHeader = `Basic ${credentials}`;
  
  // Clone the request and add the authorization header
  const authReq = req.clone({
    headers: req.headers.set('Authorization', authHeader)
  });
  
  // Pass the cloned request with the authorization header to the next handler
  return next(authReq).pipe(
    catchError(err => {
      if (err.status === 401) {
        router.navigate(['admin']);
        alertService.showError('Credenciales inválidas.', 'Por favor, inicie sesión de nuevo.');
      }
      throw err;
    })
  );
};